import React from 'react';
import AgreementServiceDetailsV3 from './agreementServiceDetailsV3';
import AgreementServiceDetailsV4 from './agreementServiceDetailsV4';

const AgreementServiceDetails = (props) => {
    if (props.version === 'V3') {
        return (
            <AgreementServiceDetailsV3
                {...props}
            />
        );
    } else {
        return (
            <AgreementServiceDetailsV4
                {...props}
            />
        );
    }
};

export default AgreementServiceDetails;
